import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LickertProportionEditCardComponent } from './lickert-proportion-edit-card.component';
import { FormControlsModule } from '../../forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderGlobeAnimationDetailComponent } from '../../loaders';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AvatarPillComponent, InlinePillPickerComponent } from '@frontend/shared';

@NgModule({
    declarations: [LickertProportionEditCardComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormControlsModule,
        LoaderGlobeAnimationDetailComponent,
        AlertModule,
        TranslocoModule,
        CollapseModule,
        AvatarPillComponent,
        InlinePillPickerComponent,
    ],
    exports: [LickertProportionEditCardComponent],
    providers: [
        { provide: TRANSLOCO_SCOPE, useValue: 'contributions' }
    ],
})
export class SurveyProportionEditCardModule { }